const chartExportTypes = {
    xlsxFull: "xlsxFull",
    xlsxNi: "xlsxNi",
    xlsxSl: "xlsxSl",
    pdf: "pdf",
    printPdf: "printPdf",
    printDiagram: "printDiagram",
    png: "png",
    svg: "svg",
    csvSl: "csvSl"
};

const exportInitial = {
    exporting: null,
    exportUsed: [],
    exception: null
}

const initialState = {
    exports: { ...exportInitial }
}

export { chartExportTypes, exportInitial, initialState as exportsInitialState };
